import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, MessageSquare } from 'lucide-react';
import { useAgentsList } from './messenger/hooks/useAgentsList';
import { ContactCard } from './messenger/components/ContactCard';

export default function MessengerPage() {
  const navigate = useNavigate();
  const { agents, loading, error } = useAgentsList();
  const [search, setSearch] = useState('');

  const filtered = agents.filter(a =>
    a.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] -mx-3 sm:-mx-6 lg:-mx-8 -mt-4">
      {/* Header */}
      <div className="bg-zinc-950 border-b border-zinc-800 px-4 py-4 shrink-0">
        <h1 className="text-lg font-bold text-white mb-3">Messenger</h1>
        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher un agent..."
            className="w-full bg-zinc-800 rounded-full pl-9 pr-4 py-2 text-sm text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50"
          />
        </div>
      </div>

      {/* Liste des agents */}
      <div className="flex-1 overflow-y-auto divide-y divide-zinc-800/60">
        {loading && (
          <div className="flex items-center justify-center py-16 text-zinc-500">
            <div className="flex flex-col items-center gap-3">
              <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
              <span className="text-sm">Chargement des agents...</span>
            </div>
          </div>
        )}

        {error && (
          <div className="flex items-center justify-center py-16 px-4">
            <p className="text-sm text-red-400 text-center">{error}</p>
          </div>
        )}

        {!loading && !error && filtered.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
            <MessageSquare className="h-12 w-12 text-zinc-700 mb-3" />
            <p className="text-sm font-medium text-zinc-400">
              {search ? 'Aucun agent trouvé' : 'Aucun agent disponible'}
            </p>
            {!search && (
              <p className="text-xs text-zinc-600 mt-1">
                Créez des agents depuis la section Agents
              </p>
            )}
          </div>
        )}

        {!loading && !error && filtered.map(agent => (
          <ContactCard
            key={agent.id}
            agent={agent}
            onClick={() => navigate(`/messenger/${agent.id}`)}
          />
        ))}
      </div>
    </div>
  );
}
